import emailjs from "@emailjs/browser";

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

if (EMAILJS_PUBLIC_KEY) {
  emailjs.init({
    publicKey: EMAILJS_PUBLIC_KEY,
    limitRate: { id: "contact-form", throttle: 10000 },
  });
}

export default emailjs;
